import { Badge } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"

/**
 * Small non-interactive label for Library cards when the signed-in user has
 * resumable registration access to the resource.
 */
export function LibraryResourceAccessBadge() {
  const { t } = useTranslate()

  return (
    <Badge variant="subtle" size="sm" pointerEvents="none" fontWeight="600">
      {t("Joined")}
    </Badge>
  )
}
